module.exports = __webpack_public_path__ + "img/logo.f39cbbb6.png";